var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateShelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.096,
    height: 40,
    viewBox: "0 0 53.096 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(-683.586 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(-6.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(690.057 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box-fragile-svgrepo-com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M50.491,51.307H2.6A2.536,2.536,0,0,0,0,53.761V88.853a2.536,2.536,0,0,0,2.6,2.454H50.491a2.536,2.536,0,0,0,2.6-2.454V53.761A2.536,2.536,0,0,0,50.491,51.307Zm.942,37.546a.917.917,0,0,1-.942.888H2.6a.917.917,0,0,1-.942-.888V53.761a.917.917,0,0,1,.942-.888H50.491a.917.917,0,0,1,.942.888V88.853Z",
    transform: "translate(0 -51.307)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(696.979 397.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M33.828,79.914H30.734V67.469a.688.688,0,0,0-.688-.688H26.471v-2.2a.688.688,0,0,0-.688-.688H21.521a.688.688,0,0,0-.688.688v4.813H17.946V66.369a.688.688,0,0,0-.688-.688H13.683V63.688A.688.688,0,0,0,13,63H8.732a.688.688,0,0,0-.688.688v1.994H4.469a.688.688,0,0,0-.688.688V79.914H.688A.688.688,0,0,0,0,80.6v2.475a.688.688,0,0,0,.688.688H3.575v4.4a.688.688,0,1,0,1.375,0v-4.4H33.828a.688.688,0,0,0,.688-.688V80.6A.688.688,0,0,0,33.828,79.914ZM26.471,68.157h2.888V79.914H26.471Zm-4.263-2.888H25.1V79.914H22.209Zm-4.263,5.5h2.888v9.145H17.946Zm-4.263-3.713H16.57V79.914H13.683ZM9.42,64.375h2.888V79.914H9.42ZM5.157,67.057H8.045V79.914H5.157ZM33.141,82.389H1.375v-1.1H33.141Z",
    transform: "translate(0 -63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M430.688,379a.687.687,0,0,0-.688.688v2.75a.688.688,0,0,0,1.375,0v-2.75A.687.687,0,0,0,430.688,379Z",
    transform: "translate(-400.434 -357.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M86.688,140a.688.688,0,0,0-.688.688v.619a.688.688,0,1,0,1.375,0v-.619A.688.688,0,0,0,86.688,140Z",
    transform: "translate(-80.087 -134.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M86.688,185a.688.688,0,0,0-.688.688v6.188a.688.688,0,1,0,1.375,0v-6.188A.688.688,0,0,0,86.688,185Z",
    transform: "translate(-80.087 -176.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M272.688,192a.688.688,0,0,0-.688.688v.38a.688.688,0,1,0,1.375,0v-.38A.688.688,0,0,0,272.688,192Z",
    transform: "translate(-253.298 -183.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M272.688,232a.688.688,0,0,0-.688.688v2.957a.688.688,0,0,0,1.375,0v-2.957A.688.688,0,0,0,272.688,232Z",
    transform: "translate(-253.298 -220.38)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-svgrepo-com_2_",
    "data-name": "add-svgrepo-com (2)",
    transform: "translate(724 391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M6,12H9.158",
    transform: "translate(-6 -10.421)",
    fill: "none",
    stroke: "#fafafa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M12,9.158V6",
    transform: "translate(-10.421 -6)",
    fill: "none",
    stroke: "#fafafa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M4.5,9A4.5,4.5,0,1,1,9,4.5,4.505,4.505,0,0,1,4.5,9ZM4.5.75A3.75,3.75,0,1,0,8.25,4.5,3.755,3.755,0,0,0,4.5.75Z",
    transform: "translate(721 388)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateShelf);
export default __webpack_public_path__ + "static/media/create-shelf.1f78b533bf7385f1f1572e7ec52d7644.svg";
export { ForwardRef as ReactComponent };